import React, { useState, useEffect } from 'react';

import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Toast } from 'react-bootstrap';
import accept from '../images/accept.png';
import { useAppSelector } from '../hooks/reduxHooks';

const Notificacion = props => {
  const { foilCode, foilKey } = useAppSelector(({ foilReducer }) => foilReducer);

  const {
    match: {
      params: { perfil },
    },
  } = props;
  const [copyButtonDisabled] = useState(false);
  const [copyButtonMessage, setCopyButtonMessage] = useState('');
  const handleCopyToClipboard = async () => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(`Folio: ${foilCode}\nClave: ${foilKey}`);
        setShowToast(true);
      } else {
        setCopyButtonMessage(`Folio: ${foilCode}\nClave: ${foilKey}`);
        setShowToast(true);
      }
    } catch (error) {
      console.error(error);
      setCopyButtonMessage(`Folio: ${foilCode}\nClave: ${foilKey}`);
      setShowToast(true);
    }
  };

  const [showToast, setShowToast] = useState(false);
  const [isFixTescucha, setIsFixTescucha] = useState(false);

  // Check if the current path contains "fix-tescucha"
  useEffect(() => {
    setIsFixTescucha(window.location.pathname.includes('fix-tescucha'));
  }, []);

  const titleText = isFixTescucha ? (
    <>
      ¡Gracias por utilizar el Sistema
      <br /> de Denuncias <strong className="enfasis2">FIX</strong>
      <strong className="enfasis">TE</strong>scucha!
    </>
  ) : (
    <>
      ¡Gracias por utilizar el Sistema
      <br /> de Denuncias <strong className="enfasis">TE</strong>scucha!
    </>
  );

  const TextForUser = isFixTescucha ? (
    <>
      <div>
        <p>Para verificar el progreso de tu solicitud en nuestro portal, por favor ten a mano tu folio y clave.</p>
        <p>
          Hemos recibido la información proporcionada y llevaremos acabo una revisión del caso. Para dar seguimiento al progreso de tu reporte te pedimos tener a la mano Folio y Clave. Si tienes alguna duda sobre el proceso o quieres proporcionar mayor información relevante para el caso te pedimos contactar a la Oficina de Ética en el correo <strong>oficinadeetica@truper.com</strong>
        </p>
      </div>
    </>
  ) : (
    <>
      <div>
        <p>Para verificar el progreso de tu solicitud en nuestro portal, por favor ten a mano tu folio y clave.</p>
        <p>
          Agradecemos tu confianza en nosotros para mejorar y promover la cultura de denuncia. Trabajaremos
          diligentemente para responderte en un plazo de 5 días hábiles. Si pasan más de 5 días, puedes revisar el
          estatus de tu solicitud en este mismo portal.
        </p>
      </div>
    </>
  );

  return (
    <div className="container-acceso">
      <Card>
        <Card.Body>
          <Card.Title className="center">
            <img src={accept} alt="TEscucha" width="80" height="80" />
            <br />
            <h2>{titleText}</h2>
          </Card.Title>
          <Container className="container-form-acceso">
            <Row className="row-form">
              <Col>
                <p className="text-center">Los datos de tu solicitud son:</p>
                <button
                  type="button"
                  className="row-form-data mx-auto rounded-pill border-0"
                  onClick={handleCopyToClipboard}
                  disabled={copyButtonDisabled}
                >
                  <p>
                    Folio: <strong className="enfasis">{foilCode}</strong>
                  </p>
                  <p>
                    Clave: <strong className="enfasis">{foilKey}</strong>
                  </p>
                </button>
                <p className="text-center mx-auto">
                  <small>
                    Puedes guardar estos datos en el portapapeles de tu dispositivo haciendo click en ellos.
                  </small>
                </p>
                <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide className="mx-auto">
                  <Toast.Header>
                    <strong className="mx-auto w-100 text-center">Copiado al portapapeles {copyButtonMessage}</strong>
                  </Toast.Header>
                </Toast>
                <br />

                {TextForUser}
              </Col>
            </Row>
            <Row className="row-form">
              <Col style={{ textAlign: 'right' }}>
                <Link to={`/home/${perfil}`} className="btn btn-truper btn-sm">
                  <FontAwesomeIcon icon={faHome} />
                  &nbsp;&nbsp;Ir a inicio
                </Link>
              </Col>
            </Row>
          </Container>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Notificacion;
